import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ventamesessinintereses',
  templateUrl: './ventamesessinintereses.component.html',
  styleUrls: ['./ventamesessinintereses.component.scss']
})
export class VentamesessininteresesComponent implements OnInit {
  urlMicrositio = environment.URL_MICROSITIO;
  urlWeb = environment.URL_WEB;
  title = 'Compra boletos del Sorteo Anáhuac 2026 a meses sin intereses';
  description = 'Venta de boletos del Sorteo Anáhuac 2026 a meses sin intereses. Consulta las fechas y los bancos participantes aquí.';
  utmUrl =  "";
  constructor(
    private titleService: Title,
    private metaTagService: Meta
  ) { }

  ngOnInit(): void {
	/*utm */
	let utmTem= localStorage.getItem('urlUtm');
	if(utmTem)this.utmUrl =utmTem;
	/* fin utm */
    this.titleService.setTitle(this.title);
		this.metaTagService.updateTag(
			{ name: 'title', content: this.title}
		);
		this.metaTagService.updateTag(
			{ name: 'description', content:  this.description}
		);

		this.metaTagService.updateTag(
				{ property: 'keywords', content: 'Nosotros'}
			);

			this.metaTagService.updateTag(
				{ property: 'og:title', content: this.title}
			);

		this.metaTagService.updateTag(
				{ property: 'og:description', content: this.description}
			);

		this.metaTagService.updateTag(
		{ property: 'og:url', content: environment.URL_WEB + '/nosotros' }
		);

		this.metaTagService.updateTag(
			{ property: 'og:image', content: environment.URL_WEB + '/assets/images/banner2_about.png' }
		  );
		  
		this.metaTagService.updateTag(
			{ name: 'twitter:title', content: this.title}
		);
		this.metaTagService.updateTag(
			{ name: 'twitter:description', content: this.description}
		);

    
  }
}
